import { createTheme } from "@mui/material/styles";
// import { deepmerge } from "@mui/utils";

declare module "@mui/material/styles/createPalette" {
  interface CommonColors {
    white: string;
    black: string;
    lightgrey: string;
    mediumgrey: string;
    grey: string;
    darkgrey: string;
    darkblue: string;
  }
}

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    xs: true; // removes the `xs` breakpoint
    sm: true;
    md: true;
    lg: true;
    xl: true;
  }
}

let PaletteTheme = createTheme({
  palette: {
    primary: {
      light: "#168f8c", // #ff5c05"
      main: "#e05e28", // "#ff5c05", //"#ed672c", // "#f75400", "#f15400"
      dark: "#d14900",
      contrastText: "#fff",
    },
    secondary: {
      light: "#2e396a",
      main: "#000416", //"#000b3c", //"#f95a62", // '#ee5052', //'#f76378',
      dark: "#000434",
      contrastText: "#fff",
    },
    common: {
      white: "#fff",
      black: "#000416",
      lightgrey: "#e4e4e4",
      mediumgrey: "#919191",
      grey: "#666",
      darkgrey: "#333",
      darkblue: "#000b3c",
    },
  },
});

const CustomTheme = createTheme(PaletteTheme, {
  // Component overrides
  components: {
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          "&:hover": {
            transform: "scale(1.02)",
          },
          fontFamily: "chevinpro-demibold,open sans,sans-serif",
        },
        outlinedSecondary: {
          // Some CSS
          backgroundColor: "#fff",
        },
      },
    },
  },
  typography: {
    fontFamily: "proxima_nova_rgregular,helvetica neue,Helvetica,Arial,sans-serif",
    h1: {
      fontSize: "1.8rem",
      fontFamily: "chevinpro-demibold,open sans,sans-serif",
      // color: PaletteTheme.palette.primary.main
    },
    h2: {
      fontSize: "1.6rem",
      fontFamily: "chevinpro-demibold,open sans,sans-serif",
      // color: PaletteTheme.palette.primary.main
    },
    h3: {
      fontSize: "1.4rem",
      fontFamily: "chevinpro-demibold,open sans,sans-serif",
      // color: PaletteTheme.palette.primary.main
    },
    h4: {
      fontSize: "1.2rem",
      fontFamily: "chevinpro-demibold,open sans,sans-serif",
      // color: PaletteTheme.palette.primary.main
    },
    h5: {
      fontSize: "1.1rem",
      fontFamily: "chevinpro-demibold,open sans,sans-serif",
      //color: PaletteTheme.palette.primary.main,
    },
    h6: {
      fontSize: "1rem",
      fontFamily: "chevinpro-demibold,open sans,sans-serif",
      //color: PaletteTheme.palette.primary.main,
    },
  },
  shape: {
    borderRadius: 12,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 375,
      md: 768,
      lg: 1180,
      xl: 1440,
    },
  },
});

export default CustomTheme;
